// extracted by mini-css-extract-plugin
module.exports = {"grid":"Exhibits_grid__npU-D","content":"Exhibits_content__2LVwt"};